/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { url } from 'utils/urls';
// material
import { CopySnippetField, Tip } from '@insticator/insticator-ui/dist/material';
import { SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './basic_styles'
import { useSelector } from 'react-redux';


/* ========== ~~~~~~~~~~ PRODUCT MANAGER: SITE SETUP : FEATURES ~~~~~~~~~~ ========== */
const Basic = injectSheet(styles)((props) => {
  
  const { siteUUID } = useSelector((state) => state.session)

  const headerCode = `<script data-cfasync="false" type="text/javascript">(function (a, c, s, u) { 'Insticator' in a || (a.Insticator = { ad: { loadAd: function (b) { Insticator.ad.q.push(b) }, q: [] }, helper: {}, embed: {}, version: "4.0", q: [], load: function (t, o) { Insticator.q.push({ t: t, o: o }) } }); var b = c.createElement(s); b.src = u; b.async = !0; var d = c.getElementsByTagName(s)[0]; d.parentNode.insertBefore(b, d) })(window, document, 'script', 'https:${url.headerCodeDistribution}/${siteUUID}.js')</script>
<script async type="text/javascript" src="${url.productLoaderCodeDistribution}/${siteUUID}.js"></script>
<script>Insticator.load('load-page', {
    pageId: '{pageId}',
  })
</script>
  `
  return (
    <SectionGroupV2 
      klass={`basic ${props.classes.basic}`} 
      title={'Basic'} 
      description={'Get the code needed to integrate products into your web pages.'}
      direction={'column'}
    >
      <CopySnippetField
        title={
          <span>Header code{' '} 
            <Tip 
              space={'none'} 
              icon={'question-circle'}
              label={''} 
              content={<>
                Place this code directly into the {'<head>'} element of your page. 
                Pass data for <a target="_blank" href="https://documentation.insticator.com/docs/what-is-external-page-id" rel="noreferrer">page-id</a> to safeguard against the loss of product data in the event your page url changes. 
                You will not see any products on your page until you “Add a Product Group” via the “Page Setup” section.
              </>} 
            />
          </span>}
        codeSnippet={headerCode || ''}
        inline
      />

    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Basic;